/**
 * Advanced Settings Page
 * Manage advanced business settings like client ownership, work schedule overlap, etc.
 */

import { createFileRoute, useParams } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { SettingsPageHeader } from '@/components/ui';
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell';
import {
  ClientOwnershipCard,
  WorkScheduleOverlapCard,
  CustomEmailAddressCard,
  ClientAccountBalancesCard,
} from './business-setup/components/advanced-settings';
import { formatDocumentTitle } from '@/lib/document-title';

export const Route = createFileRoute('/_auth/$orgId/settings/business-setup/advanced-settings')({
  component: AdvancedSettingsPage,
});

function AdvancedSettingsPage() {
  const { orgId } = useParams({ from: '/_auth/$orgId/settings/business-setup/advanced-settings' });

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Advanced Settings')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="advanced-settings">
        <SettingsPageHeader
          title="Advanced Settings"
          description={
            <>
              Manage advanced settings like client ownership for booth renter business structures
              where client lists are kept separate.
            </>
          }
        />

        <div className="max-w-2xl space-y-6">
          <ClientOwnershipCard />
          <WorkScheduleOverlapCard />
          <CustomEmailAddressCard />
          <ClientAccountBalancesCard />
        </div>
      </BusinessSetupPageShell>
    </>
  );
}
